import { INavConfig } from '@/services/system-config-service';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: initialStateType = {
  dialogOpen: false,
  dialogView: null,
  selectedNavGroup: null,
  selectedRouteGroup: null,
};

const stateSlice = createSlice({
  name: 'navBoard/state',
  initialState: initialState,
  reducers: {
    openNavGroupDialog: (state, action: PayloadAction<{ selectedNavGroup: INavConfig | null }>) => {
      state.dialogOpen = true;
      state.dialogView = 'NAV-GROUP';
      state.selectedNavGroup = action.payload.selectedNavGroup;
    },
    openRouteGroupDialog: (state, action: PayloadAction<{ selectedNavGroup: INavConfig }>) => {
      state.dialogOpen = true;
      state.dialogView = 'ROUTE-GROUP';
      state.selectedNavGroup = action.payload.selectedNavGroup;
    },
    openRouteDialog: (state, action: PayloadAction<{ selectedNavGroup: INavConfig; selectedRouteGroup: INavConfig }>) => {
      state.dialogOpen = true;
      state.dialogView = 'ROUTE';
      state.selectedNavGroup = action.payload.selectedNavGroup;
      state.selectedRouteGroup = action.payload.selectedRouteGroup;
    },
    closeDialog: (state) => {
      state.dialogOpen = false;
      state.dialogView = null;
      state.selectedNavGroup = null;
      state.selectedRouteGroup = null;
    },
  },
});

export const { openNavGroupDialog, openRouteGroupDialog, openRouteDialog, closeDialog } = stateSlice.actions;
export default stateSlice.reducer;
interface initialStateType {
  dialogOpen: boolean;
  dialogView: 'NAV-GROUP' | 'ROUTE-GROUP' | 'ROUTE' | null;
  selectedNavGroup: INavConfig | null;
  selectedRouteGroup: INavConfig | null;
}
